<div class="scss-sign-up-slot-side-bar-svg"></div>

@if (loading) {
    <div class="d-flex justify-content-center align-items-center" [ngStyle]="{'height': !isMobile ? '370px' : '300px'}">
        <div class="spinner-border"></div>
    </div>
}
<div #slotPicker></div>
@if (bookingSlots.length === 0 && !loading) {
    <div class="pb-4">
        <lib-empty-state
            [emptyStateGraphic]="EmptyStateGraphic.Calendar">
            <ng-container emptyStateText i18n="@@Common_SlotPicker_EmptyState_Title">Sorry, no times are available!</ng-container>
            <ng-container emptyStateDescription i18n="@@Common_SlotPicker_EmptyState_Description">
                Thanks for your interest! There aren't any available times at the moment. Please check back soon for new openings!
            </ng-container>
            <ng-container emptyStateButton>
                <lib-button
                    [kind]="ButtonKind.Secondary"
                    [prefixIcon]="Icon.Common.Refresh"
                    [loading]="loading"
                    [size]="ButtonSize.Large"
                    (clicked)="FetchBookingSlots()">
                        <ng-container label i18n="@@CommonTryAgain">Try Again</ng-container>
                </lib-button>
            </ng-container>
        </lib-empty-state>
    </div>
}

<div class="d-flex flex-column gap-3 scss-sign-up-slot-picker-options" [ngClass]="{'d-none': loading || bookingSlots.length === 0}">
    <div class="d-flex gap-2 justify-content-center" [ngClass]="{'flex-column': isMobile}">
        @if (isAvailabilityBookingWidget && availableTeachers.length > 1) {
            <lib-chip-button-select #teacherSelect class="d-flex justify-content-center"
                [currentSelection]="currentTeacherSelected" [disableBottomSheet]="true" (selectionChange)="TeacherChange($event)" [stretch]="isMobile">
                <ng-template #triggerTemplate let-item>
                    @if (GetCurrentTeacherSelected(item); as chipData) {
                        <div class="d-flex gap-1 align-items-center" [ngClass]="{'justify-content-center': isMobile}">
                            <lib-icon class="scss-sign-up-avatar-icon-colour" [icon]="Icon.Common.PersonVoiceOver" [size]="IconSize.ExtraSmall"></lib-icon>
                            <p class="typography-label-large base-300 px-1" data-clarity-mask="true">{{ chipData!.Label}}</p>
                        </div>
                    }
                </ng-template>
                <ng-container *ngFor="let item of teacherChipData">
                    <lib-chip-button-select-item [value]="item.Value">
                        <p class="typography-body-medium base-300" data-clarity-mask="true">{{ item.Label }}</p>
                    </lib-chip-button-select-item>
                </ng-container>
            </lib-chip-button-select>
        }
    </div>

    <lib-slot-picker class="d-flex justify-content-center"
        [bookingSlots]="availableBookingSlots"
        [isViewOnly]="isViewOnly"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [timeZones]="timeZones"
        [currentTimezone]="currentTimezone"
        (dateTimeChanged)="DateTimeChanged($event)"
        (timezoneChange)="TimeZoneChanged($event)">
    </lib-slot-picker>

    @if (filteredBookingSlots?.length) {
        <div class="d-flex flex-column gap-3 scss-sign-up-slot-picker-options">
            <p class="typography-title-small" i18n="@@CommonSignUpSlotPickerAvailableOptions">Available Options</p>
            <div class="row g-2 d-flex">
                <lib-radio-card-group 
                    (cardClicked)="SlotClicked($event)">
                    @for(item of visibleBookingSlots; track item) {
                        <lib-radio-card
                            [value]="item"
                            [hasSelectedState]="isRescheduling">
                        <ng-container title>
                            @if (item.OriginalTeacher?.Name) {
                                <span data-clarity-mask="true">{{item.OriginalTeacher?.Name}}</span>
                            } @else {
                                <ng-container i18n="@@CommonCalendarNoTeacherOption">General Event - No #Teacher# Specified</ng-container>
                            }
                        </ng-container>
                        <ng-container radioCardSuffix>
                            <lib-status-label [kind]="StatusKind.Light" [icon]="Icon.Common.Time">
                                <ng-container label>
                                    {{item.StartDate | formatTime: 'short'}} - {{item.EndDate | formatTime: 'short'}}
                                </ng-container>
                            </lib-status-label>
                        </ng-container>
                        <ng-container text>
                            <div class="d-flex gap-1 flex-wrap">
                                @if (existingEvents || !preFetchedSlots?.SubjectTag) {
                                    <lib-status-label
                                        [kind]="StatusKind.Custom"
                                        [icon]="Icon.Common.LabelTag"
                                        [labelColor]="item.EventCategory!.Color | method: BackgroundColorClass">
                                        <ng-container label>
                                            {{ item.EventCategory?.Name }}
                                        </ng-container>
                                    </lib-status-label>
                                } @else {
                                    <lib-status-label
                                        [kind]="StatusKind.Light"
                                        [icon]="subjectIcon">
                                        <ng-container label>
                                            {{ preFetchedSlots?.SubjectTag?.Name }}
                                        </ng-container>
                                    </lib-status-label>
                                }
    
                                @if (item.EventLocation; as location) {
                                    <lib-status-label [kind]="StatusKind.Custom" [icon]="location.Icon! | calendarEventLocationIcon" [labelColor]="location.Color | method: BackgroundColorClass">
                                        <ng-container label>
                                            {{location.Name}}
                                        </ng-container>
                                    </lib-status-label>
                                }
                            </div>
                        </ng-container>
                        <ng-container footer>
                            @if (!makeupCreditRequiredOnly) {
                                @if (item.PricePerParticipantUnit == PricePerParticipantUnit.PerEvent && item.PricePerParticipant > 0) {
                                    <ng-container
                                        i18n="@@TPSignUpWidgetSlotPickerPricePerLesson">{{item.PricePerParticipant | formatCurrency}} / #lesson#
                                    </ng-container>
                                }
                                @if (item.PricePerParticipantUnit == PricePerParticipantUnit.PerMonth && item.PricePerParticipant > 0) {
                                    <ng-container
                                        i18n="@@TPSignUpWidgetSlotPickerPricePerMonth">{{item.PricePerParticipant | formatCurrency}} / month
                                    </ng-container>
                                }
                                @if (!item.PricePerParticipant) {
                                    <ng-container
                                        i18n="@@TPSignUpWidgetSlotPickerPriceIsFree">Free
                                    </ng-container>
                                }
                            }
                            </ng-container>
                        </lib-radio-card>
                    }
                </lib-radio-card-group>
            </div>
            @if (filteredBookingSlots.length > 2) {
                <lib-button class="d-flex justify-content-center"
                    [kind]="ButtonKind.Link"
                    [suffixIcon]="isExpanded ? Icon.Common.ExpandLess : Icon.Common.ExpandMore"
                    (clicked)="ShowMoreClicked()">
                    <ng-container label>
                        <div [hidden]="!isExpanded" i18n="@@CommonShowLessLabel">Show Less</div>
                        <div [hidden]="isExpanded" i18n="@@CommonShowMoreLabel">Show More</div>
                    </ng-container>
                </lib-button>
            }
        </div>
    }
</div>